export default __webpack_public_path__ + "static/media/sms.a4b5d610.gif";